import { breakpoints } from '../assets/styles/_breakpoints';
let storageBreak = {};

export const mediaQueryXXS = (...referencedElements) => {
  const SIZE = 'xxs';
  const mediaQueryList = buildMatchMedia(SIZE);
  buildClassNameWithModifier(referencedElements, mediaQueryList, SIZE);
};

export const mediaQueryXS = (...referencedElements) => {
  const SIZE = 'xs';
  const mediaQueryList = buildMatchMedia(SIZE);
  buildClassNameWithModifier(referencedElements, mediaQueryList, SIZE);
};

export const mediaQueryS = (...referencedElements) => {
  const SIZE = 's';
  const mediaQueryList = buildMatchMedia(SIZE);
  buildClassNameWithModifier(referencedElements, mediaQueryList, SIZE);
};

export const mediaQueryM = (...referencedElements) => {
  const SIZE = 'm';
  const mediaQueryList = buildMatchMedia(SIZE);
  buildClassNameWithModifier(referencedElements, mediaQueryList, SIZE);
};

export const mediaQueryL = (...referencedElements) => {
  const SIZE = 'l';
  const mediaQueryList = buildMatchMedia(SIZE);
  buildClassNameWithModifier(referencedElements, mediaQueryList, SIZE);
};

const buildMatchMedia = (SIZE) => {
  return window.matchMedia(`(min-width: ${breakpoints[SIZE].size})`);
};

const buildClassNameWithModifier = (
  referencedElements,
  mediaQueryList,
  SIZE
) => {
  referencedElements.forEach((element) => {
    if (element.current) {
      element.current.className = getClassMedia(
        mediaQueryList.matches,
        element.current,
        SIZE
      );
      addListener(element, mediaQueryList, SIZE);
    }
  });
};

const addListener = (element, mediaQueryList, size) => {
  mediaQueryList.addEventListener('change', (event) => {
    element.current.className = getClassMedia(
      event.matches,
      element.current,
      size,
      event
    );
  });
};

const getClassMedia = (matches, currentElement, SIZE, event) => {
  const concatModifier = `--${SIZE}`;
  const currentModifier = getCurrentModifier(currentElement.className);

  if (matches) {
    const pureClassName = getPureClassName(
      currentModifier,
      currentElement.className
    );
    saveCurrentAndPrevModifier(pureClassName, concatModifier, currentModifier);
    return pureClassName + concatModifier;
  } else {
    const currentSize = currentModifier.replace('--', '');
    const shouldGoBack =
      sortedBreakpoints.indexOf(SIZE) <= sortedBreakpoints.indexOf(currentSize);

    return shouldGoBack
      ? goBackUntilMatch(currentElement, currentElement.className)
      : currentElement.className;
  }
};

const getCurrentModifier = (className) => {
  let currentModifier = '';
  sortedBreakpoints.forEach((breakPoint) => {
    const modifierToCompare = `--${breakPoint}`;
    if (className.includes(modifierToCompare)) {
      if (className.split(modifierToCompare).length === 2) {
        currentModifier = modifierToCompare;
      }
    }
  });
  return currentModifier;
};

const getPureClassName = (currentModifier, currentElementClassName) => {
  return currentModifier === ''
    ? currentElementClassName
    : currentElementClassName.split(currentModifier)[0];
};

const saveCurrentAndPrevModifier = (
  pureClassName,
  concatModifier,
  currentModifier
) => {
  sortedBreakpoints.forEach((breakPoint) => {
    if (
      !storageBreak[`${pureClassName}${concatModifier}`] &&
      concatModifier !== `--${breakPoint}`
    ) {
      storageBreak = {
        ...storageBreak,
        [`${pureClassName}${concatModifier}`]: {
          previousModifier: currentModifier,
        },
      };
    }
  });
};

const goBackUntilMatch = (currentElement, className) => {
  const currentModifier = getCurrentModifier(currentElement.className);
  const storagedPrevModifier = storageBreak[`${className}`]
    ? storageBreak[`${className}`].previousModifier
    : '';
  const prevModifier = storagedPrevModifier || currentModifier;

  if (prevModifier === '') {
    return currentElement.className;
  }
  const modifierSize = prevModifier.replace('--', '');
  const pxBreak = Number(breakpoints[modifierSize]?.size.replace('px', ''));

  removeAllModifiers(currentElement);
  const newClassName = currentElement.className + prevModifier;
  if (window.screen.availWidth >= pxBreak) {
    return newClassName;
  }

  return goBackUntilMatch(currentElement, newClassName);
};

const sortedBreakpoints = Object.entries(breakpoints)
  .sort(
    (firstEl, secondEl) =>
      Number(firstEl[1].size.replace('px', '')) -
      Number(secondEl[1].size.replace('px', ''))
  )
  .map((el) => el[0]);

const cleanClassName = (className, modifier) => className.split(modifier)[0];

const removeAllModifiers = (currentElement) => {
  sortedBreakpoints.forEach((breakPoint) => {
    const modifierToRemove = `--${breakPoint}`;
    const currentClassName = currentElement.className;
    if (currentClassName.includes(modifierToRemove)) {
      currentElement.className = cleanClassName(
        currentClassName,
        modifierToRemove
      );
    }
  });
};
